<script setup>
import { useMainStore } from '../stores/main-store'
import CategorySection from './CategorySection.vue'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const mainStore = useMainStore()
</script>

<template>
  <template v-if="mainStore.filteredSections.length">
    <template v-for="category in mainStore.filteredSections" :key="category.id">
      <CategorySection
        :products="category.products"
        :category="category"
        :title="category.title"
        :description="category.description"
      />
    </template>
  </template>
  <div v-else class="no-collection-results">
    {{ __('There were no results!', 'lavnosrad') }}
  </div>
</template>
